const STARTING_TIME = 90;
const MINIMUM_TIME = 10;

export const getLevelTime = (levelNumber) => (
  Math.max(MINIMUM_TIME, STARTING_TIME - ((levelNumber - 1) * 5))
);
